const loggedMessages = /* @__PURE__ */ new Set();
let esriConfig;
const setEsriConfig = (config) => {
  esriConfig = config;
};
const getContextString = (context) => {
  if (typeof context === "string") {
    return context;
  }
  if ("el" in context) {
    return context.el.localName;
  }
  if ("localName" in context) {
    return context.localName;
  }
  return context.declaredClass;
};
const log = (level, context, message, options) => {
  const contextString = getContextString(context);
  if (options?.once) {
    const key = `${level}${contextString}${message}`;
    if (loggedMessages.has(key)) {
      return;
    }
    loggedMessages.add(key);
  }
  let memorySafeDetail;
  if (options?.detail) {
    memorySafeDetail = {};
    for (const [key, value] of Object.entries(options.detail)) {
      if ((typeof value === "object" || typeof value === "function") && value !== null) {
        const weakRefValue = new WeakRef(value);
        Object.defineProperty(memorySafeDetail, key, {
          enumerable: true,
          get() {
            return weakRefValue.deref();
          }
        });
      } else {
        memorySafeDetail[key] = value;
      }
    }
    esriConfig?.log.interceptors?.forEach(
      (interceptor) => interceptor(level, contextString, message, memorySafeDetail)
    );
    console[level](`[${contextString}]: ${message}`, memorySafeDetail);
  } else {
    esriConfig?.log.interceptors?.forEach((interceptor) => interceptor(level, contextString, message));
    console[level](`[${contextString}]: ${message}`);
  }
};
const rethrowError = (context) => {
  const prefix = `[${getContextString(context)}] `;
  return (error) => {
    const errorToRethrow = error instanceof Error && error.message ? error : new Error(String(error));
    errorToRethrow.message = `${prefix}${errorToRethrow.message}`;
    setTimeout(() => {
      throw error;
    });
  };
};
const composeMissingPropertyMessage = (property) => (
  //#endregion composeMissingPropertyMessage
  `The property \`${property.toString()}\` is required but missing.`
);
const composeEmptyPropertyMessage = (property) => (
  //#endregion composeEmptyPropertyMessage
  `The property \`${property.toString()}\` is empty but must have at least one element.`
);
const logDeprecatedProperty = (context, oldName, newName, options) => (
  //#endregion logDeprecatedProperty
  log("warn", context, `\`${oldName.toString()}\` is deprecated. Use \`${newName.toString()}\` instead.`, options)
);
export {
  composeEmptyPropertyMessage,
  composeMissingPropertyMessage,
  log,
  logDeprecatedProperty,
  rethrowError,
  setEsriConfig
};
